import { DeclarationDrBase } from './declaration-dr.base.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationDpRecoltant extends DeclarationDrBase {
    static jsonMap = {
        ...DeclarationDrBase.jsonMap,
        recolte_totale: { key: 'recolte_totale' },
        superficie_recolte: { key: 'superficie_recolte' },
        vci: { key: 'vci' },
        vsi: { key: 'vsi' },
        vol_en_vinification: { key: 'vol_en_vinification' },
        vol_non_vinifie: { key: 'vol_non_vinifie' },
        vol_vinrevendicable_ou_commercialisable: { key: 'vol_vinrevendicable_ou_commercialisable' },
        details: { key: 'list', converter: new (ArrayClassConverterFactory.build(DeclarationDpRecoltant))(), optional: true, default: () => [] }
    };

    recolte_totale: number;
    superficie_recolte: number;
    vci: number;
    vsi: number;
    vol_en_vinification: number;
    vol_non_vinifie: number;
    vol_vinrevendicable_ou_commercialisable: number;
    details: DeclarationDpRecoltant[];
}
